<template>
  <b-card class="shipping-photos" v-if="photos.length > 0">
    <h4 v-translate>Photos</h4>
    <b-row class="pt-3">
      <b-col class="text-center mb-3" v-for="photo in photos" :key="photo.id">
        <a href="#" v-b-modal.modalShowShippingPicture @click.prevent="$emit('select', !attachmentIsPdf(photo.full_path) ? photo.full_path : photo)" class="d-inline-block text-center">
          <div style="width: 150px; max-height: 150px;" v-if="!attachmentIsPdf(photo.full_path)">
            <img :src="photo.full_path" alt="" style="max-height: 150px; width: auto;" class="img-thumbnail" />
          </div>
          <div style="width: 150px; height: 150px;" class="d-flex justify-content-center align-items-center img-thumbnail" v-else>
            <font-awesome-icon icon="file-pdf" style="font-size: 60px; vertical-align: middle;" class="text-danger"/>
          </div>
        </a><br>{{statusStringsByType[photo.type]}}
        <small class="d-block" v-if="photo.created_at">{{moment.utc(photo.created_at).tz(tz).format('L LT')}}</small>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import constants from '@/common/constants'

export default {
  props: {
    shipping: {
      type: Object,
      required: true
    },
    excludeStatusHistoryPhotos: {
      type: Boolean,
      default: false
    }
  },
  mixins: [constants],
  computed: {
    photos() {
      const photos = (this.shipping.photos || []).filter(photo => photo.type !== 'SIGNATURE' && photo.type !== 'MANIFEST')
      if (!this.excludeStatusHistoryPhotos) {
        return photos
      }
      // Same condition ShippingStatusHistory uses to show the picture icon on a status
      const statusesWithPicture = (this.shipping.status_history || []).filter(status => status.details && status.details.reason && (status.details.picture || status.details.shippingPhoto))
      return photos.filter(photo => !statusesWithPicture.some(status =>
        (status.details.shippingPhoto && status.details.shippingPhoto.id === photo.id) || status.details.picture === photo.full_path
      ))
    },
    statusStringsByType() {
      return this.shipping.shipping_type.name !== 'reverse' ? this.statusStrings.normal : this.statusStrings.reverse
    },
    tz() {
      if (!this.shipping.address_to) {
        return this.$tz
      }
      const frontConfig = window.countries.find(x => x.iso_code === this.shipping.address_to.country).front_config
      return this.$cookies.get('bypassCountry') || !frontConfig.i18n.tz ? 'UTC' : frontConfig.i18n.tz
    }
  },
  methods: {
    attachmentIsPdf(url) {
      return (url = url.substr(1 + url.lastIndexOf('/')).split('?')[0].split('#')[0]).substr(url.lastIndexOf('.')) === '.pdf'
    }
  }
}
</script>
